// extracted by mini-css-extract-plugin
module.exports = {"changeLanguage":"styles_changeLanguage__S3SnH","panel":"styles_panel__2IIvi","panel_item":"styles_panel_item__3SWQ0"};